import { createRouter, createWebHistory } from 'vue-router'
// import Home from '../views/Home.vue'
import PdfView from '../views/PdfView.vue'

const routes = [
  {
    path: '/',
    name: 'PdfView',
    component: PdfView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
